import { render, staticRenderFns } from "./SliderInfinite.vue?vue&type=template&id=b15838f2&"
import script from "./SliderInfinite.vue?vue&type=script&lang=js&"
export * from "./SliderInfinite.vue?vue&type=script&lang=js&"
import style0 from "./SliderInfinite.vue?vue&type=style&index=0&id=b15838f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports